/* eslint-disable no-unused-vars */
import { createApp } from 'vue'
import $ from 'jquery';
import App from '@/templates/App.vue'
import store from './store';
import router from "@/router";
import "@/assets/css/nucleo-icons.css";
import "@/assets/css/nucleo-svg.css";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import SoftUIDashboard from "@/templates/soft-ui-dashboard";
// API de datos de Bootstrap (data-bs-toggle de dropdowns, modales y tooltips) para toda la app.
// Antes llegaba de rebote cuando alguna vista importaba tooltip.js.
import "bootstrap/dist/js/bootstrap";
import urls_server from './config/urls_server';
import base from "@/config/base";
import api_provider from './providers/api_provider';
import useful_functions from './providers/useful_functions';
import "@/assets/css/migps.css";
import SecuredWebStorage from 'secured-web-storage';
import "@/assets/js/google_jquery.min.js";
import "@/assets/css/google_fonts.css";
import "@/assets/js/fontawesome.js";
import "@/assets/css/font-awesome-6.3.0-all.min.css";
import "@/assets/css/datatables.css";
import '@/assets/css/pagination.css';
import 'remixicon/fonts/remixicon.css';
import VsudSelectMultipleSearch from '@/components/VsudSelectMultipleSearch.vue';
import { demoFieldClass, demoFieldValue } from '@/providers/demo_mask';

L.Icon.Default.mergeOptions({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.isAuthenticated)) {
    if (!store.getters.loggedIn) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

var securedWebStorage = new SecuredWebStorage({name: base.SECUREDWSNAME, type: 'localStorage', secretKey: base.SECUREDWSPASS});
export default securedWebStorage;

const app = createApp(App);
app.component('VsudSelectMultipleSearch', VsudSelectMultipleSearch);
// Modo demo: disponible en todos los templates sin tener que importarlo componente a
// componente, porque las celdas sensibles estan repartidas por todos los listados.
app.mixin({ methods: { demoFieldClass, demoFieldValue } });
app.use(router);
app.use(store);
app.use(SoftUIDashboard)
app.provide('urls_server', urls_server)
app.provide('api_provider', api_provider)
app.provide('useful_functions', useful_functions)
app.provide('securedWebStorage', securedWebStorage)

app.mount('#app');
export { app };
